import styled from "styled-components";
export const ReviewWrapper = styled.div`
  padding: 15px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
  border-radius: 15px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  @media (min-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }
  gap: 20px;
  .text-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    .heading {
      font-size: 16px;
      line-height: 20px;
      font-weight: 300;
      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 22px;
      }
      margin-bottom: 20px;
    }
    .Rating-wrapper {
      font-size: 16px;
      line-height: 20px;
      font-weight: 300;
      margin-bottom: 20px;
      .review-info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 20px;
        margin-bottom: 10px;
        padding-top: 10px;
        strong {
          font-size: 18px;
          line-height: 22px;
          font-weight: 500;
        }
      }
      .positive-rating {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 20px;
        color: #289a00;
        svg {
          width: 22px;
          height: 22px;
          background-color: #289a00;
          border-radius: 50%;
          padding: 4px;
          color: #fff;
        }
      }
      .negative-rating {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 20px;
        color: #e00000;
        svg {
          width: 22px;
          height: 22px;
          background-color: #e00000;
          border-radius: 50%;
          padding: 4px;
          color: #fff;
        }
      }
    }
  }
`;


